import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import SexStats from './SexStats';
import SkillStats from './SkillStats';
import AgeStats from './AgeStats';

class FollowStatistics extends PureComponent {
    static propTypes = {
        skills: PropTypes.array,
        sexStats: PropTypes.object,
        ages: PropTypes.array,
        numberOfProfiles: PropTypes.number,
    };

    render() {
        if (!this.props.skills) return null;

        const sexStats =
            this.props.numberOfProfiles > 0 ? (
                <SexStats {...this.props.sexStats} />
            ) : null;

        return (
            <React.Fragment>
                <div className="panel">
                    <h2>Følgeranalyse</h2>

                    <p className="u-mb32">
                        {this.props.numberOfProfiles} av følgerne deres har en
                        interesseprofil på FINN. Analysen er basert på
                        informasjon fra disse kandidatene.
                    </p>
                </div>
                <div className="grid t-grid">
                    <div className="grid__unit u-r-size4of5">
                        <div className="panel">
                            <SkillStats skills={this.props.skills} />
                        </div>
                    </div>
                    <div className="grid__unit u-r-size1of5">
                        {sexStats}

                        <AgeStats ages={this.props.ages} />
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default FollowStatistics;
